module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4r5r1n2n-97fa5dc42e3ef6f496de3ff2efb6126e.svg";